import { FieldSchemaType } from 'lib/fields';

export const SUPPORTED_RESOLVED_INPUT_TYPES = [
  'report-fields',
  'verification-fields',
  'input-args',
  'list-item-fields',
  'case-fields',
  'transaction-fields',
  'account-fields',
  'input-fields',
  'inquiry-fields',
];

export const TRIGGER_DEFINITION_PANEL_SUPPORTED_SCHEMA_TYPES = [
  FieldSchemaType.String,
  FieldSchemaType.Number,
  FieldSchemaType.MultiChoices,
  FieldSchemaType.Choices,
  FieldSchemaType.Json,
  FieldSchemaType.Integer,
  FieldSchemaType.Hash,
  FieldSchemaType.Date,
  FieldSchemaType.Boolean,
];

export const WORKFLOW_SIMULATE_CONTROL_PANEL_WIDTH = 400;
